// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J9BE","fullView":"styles_fullView__1bi-K"};